import { useMemo } from 'react';
import { timeToString } from 'helpers';

const useDuration = (
    duration?: number | null,
): string | null => {
    const memoizedDuration = useMemo(() => {
        if (duration === null || duration === undefined) {
            return null;
        } else {
            return timeToString(duration * 1000);
        }
    }, [duration]);

    return memoizedDuration;
};

export default useDuration;
